import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWaterNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M16.49 3.433a1 1 0 00-1.647 0C14.089 4.53 13.214 5 12 5s-2.089-.47-2.842-1.567L7.51 4.567C8.606 6.16 10.076 7 12 7c1.478 0 2.688-.495 3.667-1.447C16.645 6.505 17.855 7 19.333 7c1.925 0 3.395-.839 4.491-2.433l-1.648-1.134C21.423 4.53 20.547 5 19.333 5s-2.088-.47-2.842-1.567zM8.334 10a1 1 0 01.824.433C9.91 11.53 10.786 12 12 12c1.214 0 2.09-.47 2.843-1.567a1 1 0 011.648 0C17.244 11.53 18.119 12 19.333 12c1.214 0 2.09-.47 2.843-1.567l1.648 1.134C22.728 13.16 21.258 14 19.334 14c-1.479 0-2.689-.495-3.667-1.447C14.688 13.505 13.478 14 12 14c-1.478 0-2.688-.495-3.667-1.447C7.355 13.505 6.145 14 4.667 14c-1.925 0-3.395-.839-4.491-2.433l1.648-1.134C2.578 11.53 3.453 12 4.667 12s2.089-.47 2.842-1.567A1 1 0 018.334 10zM8.334 17a1 1 0 01.824.433C9.91 18.53 10.786 19 12 19c1.214 0 2.09-.47 2.843-1.567l1.648 1.133C15.395 20.161 13.925 21 12 21c-1.479 0-2.689-.495-3.668-1.447C7.355 20.505 6.145 21 4.667 21c-1.925 0-3.395-.839-4.491-2.434l1.648-1.133C2.578 18.53 3.453 19 4.667 19s2.089-.47 2.842-1.567A1 1 0 018.333 17z" />
      </g>
    </svg>
  )
);
SvgSportsWaterNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWaterNormalSmall;
